<script>
	import { onMount } from "svelte";
	export let user;
	export let key;
	export let onLogout;

	let messages = [];
	let newMessage = "";
	let keyExpiry = "";

	onMount(async () => {
		let key = document.getElementById("key").innerHTML;
		let keyLength = key.length;
		let keyAsterisk = key.substring(0, 4);
		for (let i = 4; i < keyLength - 4; i++) {
			keyAsterisk += "*";
		}
		keyAsterisk += key.substring(keyLength - 4, keyLength);
		document.getElementById("key").innerHTML = keyAsterisk;

		document
			.getElementById("destroy")
			.addEventListener("click", toggleButton);

		// Fetch chat history
		await fetchChatHistory();
		await getKeyExpiry();
		// Set up an interval for checking new messages every 5 seconds
		const interval = setInterval(async () => {
			await checkKey();
			await fetchChatHistory();
		}, 5000);
		return () => {
			// Clear the interval when the component is destroyed
			clearInterval(interval);
		};
	});

	async function fetchChatHistory() {
		// Make a GET request to fetch the chat history
		const response = await fetch(process.env.CHATHISTORY, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ key_hex: key }),
		});
		if (response.ok) {
			const data = await response.json();
			messages = data; // Assuming the server returns an array of messages
			// chat.append({'timestamp': message_dict['timestamp'], 'user': message_dict['user'], 'message': decrypted_message})
			// return jsonify(chat)
			messages = [];
			for (let i = 0; i < data.length; i++) {
				let message_dict = data[i];
				let final_message =
					message_dict["timestamp"] +
					" | " +
					message_dict["user"] +
					": " +
					message_dict["message"];
				messages.push(final_message);
				// console.log(message_dict);
			}
		} else {
			console.error("Failed to fetch chat history");
		}
	}

	async function sendMessage() {
		// Send the new message to the server
		const response = await fetch(process.env.CHAT, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ user, key_hex: key, message: newMessage }),
		});
		if (response.ok) {
			newMessage = ""; // Clear the input field on successful send
			await fetchChatHistory(); // Refresh the chat history
		} else {
			console.error("Failed to send message");
		}
	}

	async function destroy() {
		// Send destroy request to the server
		const response = await fetch(process.env.DESTROY, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ key_hex: key }),
		});
		if (response.ok) {
			// Call onLogout after successful destruction
			onLogout();
		} else {
			console.error("Failed to destroy chat room");
		}
	}

	function toggleKey() {
		// replace all but first 4 and last 4 characters with asterisks
		// only if key doesn't already have asterisks
		if (document.getElementById("key").innerHTML.includes("*")) {
			document.getElementById("key").innerHTML = key;
		} else {
			let key = document.getElementById("key").innerHTML;
			let keyLength = key.length;
			let keyAsterisk = key.substring(0, 4);
			for (let i = 4; i < keyLength - 4; i++) {
				keyAsterisk += "*";
			}
			keyAsterisk += key.substring(keyLength - 4, keyLength);
			document.getElementById("key").innerHTML = keyAsterisk;
		}

		setTimeout(keyHide, 5000);
	}

	function keyHide() {
		let key = document.getElementById("key").innerHTML;
		let keyLength = key.length;
		let keyAsterisk = key.substring(0, 4);
		for (let i = 4; i < keyLength - 4; i++) {
			keyAsterisk += "*";
		}
		keyAsterisk += key.substring(keyLength - 4, keyLength);
		document.getElementById("key").innerHTML = keyAsterisk;
	}
	async function checkKey() {
		// Send destroy request to the server
		const response = await fetch(process.env.CHECKKEY, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ key_hex: key }),
		});
		if (response.ok) {
			const data = await response.json();
			if (data["message"] == "False") {
				// Call onLogout after successful destruction
				onLogout();
			}
		} else {
			console.error("Failed to get key");
		}
	}
	async function getKeyExpiry() {
		const response = await fetch(process.env.KEYEXPIRY, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ key_hex: key }),
		});
		if (response.ok) {
			const data = await response.json();
			keyExpiry = data["expiry"];
			if(Date.now() > keyExpiry) {
				onLogout(); // this should work
			}
		} else {
			console.error("Failed to fetch chat history");
		}
	}
	// when checkbox is clicked, toggle the button
	function toggleButton() {
		var checkbox = document.getElementById("destroy");
		var button = document.getElementById("destroy_button");
		if (checkbox.checked == true) {
			button.disabled = false;
			button.classList.remove("is-blocked");
			button.classList.add("is-danger");
		} else {
			button.disabled = true;
			button.classList.add("is-blocked");
			button.classList.remove("is-danger");
		}
	}
</script>

<div class="section">
	<div id="main" class="container box">
		<h2 class="title is-3">Quantum Key Distribution Chat Room</h2>
		<div class="block">
			<div id="key">{key}</div>
			<h3 class="title is-4">Key Options</h3>
			<div class="columns" style="text-align:center;">
				<div class="column">
					<button
						class="button is-medium is-dark"
						type="button"
						on:click={toggleKey}
					>
						View Key
					</button>
				</div>
				<div class="column">
					<div class="rows">
						<div class="row">
							<button
								class="button is-medium is-blocked"
								id="destroy_button"
								type="button"
								on:click={destroy}
								disabled
							>
								Destroy Key and Chat Room
							</button>
						</div>
						<br />
						<div class="row">
							<input
								class="is-checkradio"
								id="destroy"
								type="checkbox"
								name="destroy"
							/>
							<label for="destroy"
								>I acknowledge that all data will be deleted
								immediately instead of at this key's expiry on {keyExpiry}</label
							>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="block">
			<h3 class="title is-4">Chat History</h3>
			<div class="field has-addons">
				<div class="control is-expanded">
					<input
						class="input"
						type="text"
						bind:value={newMessage}
						placeholder="Type message here..."
					/>
				</div>
				<br />
				<div class="control">
					<button class="button is-link" on:click={sendMessage}
						>Send</button
					>
				</div>
			</div>
		</div>
		<div id="response">
			{#each messages as message}
				<p class="chat-message">{message}</p>
			{/each}
		</div>
		<div class="block">
			<h3 class="title is-4">How It Works</h3>
			<div class="card">
				<div class="card-content">
					<div class="content">
						QuantumChat uses a quantum key distribution (QKD)
						protocol (BB84) to securely generate a shared key
						for any amount of users. The key is used to encrypt and
						decrypt messages sent between all users, and QKD ensures 
						no sensitive data is ever leaked in transit. The key is
						destroyed after a certain amount of time (default 30
						days) or when <strong>any</strong> user who posesses the
						key chooses to destroy it. (So keep your key safe!)
					</div>
				</div>
			</div>
			<br />
			<p>
				<strong
					>Why is this more secure than a chat room with classical
					encryption?</strong
				>
			</p>
			<br />
			<div class="card">
				<div class="card-content">
					<div class="content">
						<p>
							QuantumChat is more secure because QKD fundamentally
							relies on concepts which prevent eavesdroppers from
							intercepting the decrypted shared key, whereas
							classical encryption has no such protection.
						</p>
						<br />
						<p>
							Additionally, QuantumChat is more secure because it
							uses a quantum key distribution protocol (BB84) to
							generate the shared key, which is more secure than
							classical encryption algorithms such as RSA which
							factors large numbers to generate a shared key.
						</p>
						<br />
						<p>
							Note for math/physics/computer science geeks:
							QuantumChat does not use quantum encryption, which
							is a different concept than quantum key
							distribution. Quantum encryption is not currently
							possible due to the no-cloning theorem, since you
							cannot directly encrypt content using quantum states.
						</p>
					</div>
					<section>
						<div class="video-container">
							<div class="aspect-ratio">
								<iframe title="Cloning Video" src="https://www.youtube.com/embed/owPC60Ue0BE" allowfullscreen></iframe>
							</div>
						</div>
					</section>
				</div>
			</div>
			<br />
			<p><strong>Essential Terms in Quantum Computing</strong></p>
			<br />
			<div class="card">
				<div class="card-content">
					<div class="content">
						<p>
							Classical Bit: 0 or 1, what we use in our computers
							today.
						</p>
						<p>Qubit: 0, 1, or a superposition of both.</p>
						<p>
							Superposition: A state in which a qubit is both 0
							and 1 at the same time, and only collapses to one of
							those states when measured.
						</p>
						<p>
							Measurement: The process of collapsing a qubit from
							a superposition to a classical bit (into a 0 or 1).
						</p>
						<p>
							Hadamard Gate: A gate that puts a qubit into a
							superposition.
						</p>
						<p>
							NOT Gate: A gate that flips a qubit from 0 to 1 or
							vice versa.
						</p>
					</div>
				</div>
			</div>
			<br />
			<p><strong>Custom Code for BB84 Protocol</strong></p>
			<br>
			<div class="card">
				<div class="card-content">
					<div class="content">
						<p>
							For simplicity, assume Alice has 25 bits and she wants to send a message to Bob.
						</p>
						<p>Step 1: Alice randomly makes her bits either 0 or 1. She also creates a list of bases the same length as the qubit count (25), and assigns either an s or h to each base.</p>
						<p>Step 2: Alice encodes the qubits based on the both her bit value and her base value at that qubit index. If the base is s, she does nothing. If the base is h, she applies a Hadamard gate to the qubit at the current index, placing it into superposition. If her bit at that index is equal to 1, flip it to 0 using a NOT gate.</p>
						<p>Step 3: Bob creates his bases (just like Alice in Step 1), and randomly 'superimposes' the qubits (the same as putting them into superposition) based on if his base is h at that qubit index.</p>
						<p>Step 4: The qubits are each measured, taking them out of superposition and assigning them a value of 0 or 1.</p>
						<p>Step 5: Alice and Bob compare their bases. If they match, they store the value of the bit (either 1 or 0) at that index (where the bases [either s or h] match). If they don't match, they discard the bit value. This is because if the bases don't match, the qubit could have been flipped during transmission due to quantum noise and interference, so the bit value is not reliable (again, see no-cloning theorem).</p>
						<p>Step 6: The shared key is the aforementioned list in Step 5, containing the value of the bits. The amount of qualifying bits will vary as well as the indicies of the qualifying bits themselves, and when passed into a classical encryption function (this still maintains QKD levels of security) to encrypt regular plaintext, create a far more secure algorithm than using traditional prime number multiplication methods to generate shared keys.</p>
						<p><code>import cirq</code></p>
<p><code>import random</code></p>
<p><code>num_qubits = 25</code></p>
<p>    <code>qubits = [cirq.LineQubit(i) for i in range(num_qubits)]</code> </p>
<br>
<p>		# Step 1 </p>
<p>    <code>alice_bits = [random.choice([0, 1]) for _ in range(num_qubits)]</code></p>
<p>    <code>alice_bases = [random.choice(['s', 'h']) for _ in range(num_qubits)]</code></p>
<p>    <code>circuit = cirq.Circuit()</code></p>
<br>
<p>     # Step 2</p>
<p>    <code>for i in range(num_qubits):</code></p>
<p>        <code>if alice_bases[i] == 'h':</code></p>
<p>            <code>circuit.append(cirq.H(qubits[i]))</code></p>
<p>        <code>if alice_bits[i] == 1:</code></p>
<p>            <code>circuit.append(cirq.X(qubits[i]))</code></p>
<br>
<p>     # Step 3</p>
<p>    <code>bob_bases = [random.choice(['s', 'h']) for _ in range(num_qubits)]</code></p>
<p>    <code>for i in range(num_qubits):</code></p>
<p>        <code>if bob_bases[i] == 'h':</code></p>
<p>            <code>circuit.append(cirq.H(qubits[i]))</code></p>
<br>
<p>     # Step 4</p>
<p>    <code>circuit.append(cirq.measure(*qubits, key='bob_measure'))</code></p>
<p>    <code>simulator = cirq.Simulator()</code></p>
<p>    <code>result = simulator.run(circuit, repetitions=1)</code></p>
<p>    <code>measurements = result.measurements['bob_measure'][0]</code></p>
<br>
<p>     # Step 5</p>
<p>    <code>shared_key = []</code></p>
<p>    <code>for i in range(num_qubits):</code></p>
<p>        <code>if alice_bases[i] == bob_bases[i]:</code></p>
<p>            <code>shared_key.append(measurements[i])</code></p>
<br>
<p>		# Step 6</p>
<p>    <code>print(shared_key)</code></p>

					</div>
				</div>
			</div>
			<br>
			<h3 class="title is-4">Contact Me</h3>
			<div class="card">
				<div class="card-content">
					<div class="content">
						<p>Questions? Comments? Suggestions?</p>
						<br>
						<p>Contact me through my website <a href="https://grahamzemel.com/contact" style="text-decoration:none;">here</a> and I'll get back to you!</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
